import React, { Component } from 'react';
//import Product from './product.js';
import Breadcrumbs from './breadcrumbs.js';
import Filters from './filters.js';
import Productlist from './productlist.js';

class Products extends Component {
	
  	render() {
        
            let config =  	this.props.config;
            let path =  	this.props.path;
            //let currentCategory = config.categories.find(h => h.path === path.substring(1));
            //let products = currentCategory.products;

  		return (
                 <div className="main">
                <Breadcrumbs path={path} config={config} />
                <Filters path={path} config={this.props.config} />
                <Productlist path={path} config={this.props.config} auth={this.props.auth} />
                </div>

  		)
  	}
}

export default Products;
